import React from 'react';

export default function PlusIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M20.5 12.7143H13.2143V20H10.7857V12.7143H3.5V10.2857H10.7857V3H13.2143V10.2857H20.5V12.7143Z" fill="white"/>
    </svg>
  );
}
